module.exports = __webpack_public_path__ + "static/media/find-yourselves.7eaa950e.png";